export const MAX_INTERACTION_PLANE_SIZE = 300;
export const MAX_INTERACTION_PLANE_HALF_SIZE = MAX_INTERACTION_PLANE_SIZE / 2;
export const SELECTED_HANDLE_INTERACTION_Z = 0.12;
export const SELECTED_HANDLE_RENDER_ORDER = 10000;
